import * as yup from 'yup';

export interface IPayrollCompany {
    id: number;
    companyCode: string;
    payrollCompanyName: string;
    address: string;
    payment_Mode: string;
    payment_Type_Code: string;
    account_No: string;
    bank_Name_Id: number;
    logo: string;
    stamp: string;
    status: boolean;
    header_Image: string;
    footer_Image: string
    CIN: string,
    website: string,
    directors?: any[];
    auditors?: any[];
    pfConsultants?: any[];
    country: string;
    state: string;
    city: string;
    zipCode: number;
}

export interface IAddBranchInPayroll {
    id?: number
    payroll_Company_Id?: number,
    company_Id: number,
    branch_Id: number,
    status?: boolean
}


export const emptyAddBranchInPayroll: IAddBranchInPayroll = {
    company_Id: 0,
    branch_Id: 0,
}

export const schema = yup.object().shape({
    company_Id: yup.number().required('Company required').min(1, "Company required"),
    branch_Id: yup.number().required('Branch required').min(1, "Branch required"),
});

export const sortOptions: string[] = [
    "PayRoll Company Name (A-Z)",
    "PayRoll Company Name (Z-A)",
];

export const sortMapping: Record<string, { field: string; order: 1 | -1 }> = {
    "PayRoll Company Name (A-Z)": { field: "payrollCompanyName", order: 1 },
    "PayRoll Company Name (Z-A)": { field: "payrollCompanyName", order: -1 },
};



